type LiveNavLink = {
    name: string;
    slug: string;
};

export const LIVE_NAV_TITLE = 'LIVE';

export const LIVE_NAV_ITEMS: LiveNavLink[] = [
    { name: 'TNF LIVE', slug: '/events/tnf-live/' },
    { name: 'TNF рекомендует', slug: '/community/gastrofestival-tnf-rekomenduet/' },
    { name: 'Городское пространство TNF', slug: '/community/gorodskoe-prostranstvo-tnf/' },
];

export const LIVE_NAV = {
    name: LIVE_NAV_TITLE,
    links: LIVE_NAV_ITEMS,
};
